<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2020-09-30 11:16:01
-->
<template>
  <div>
    <div class="main">
      <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">公告公示</div>
        <div class="nav">
          <a
            :class="{ on: item.dictValue == tid }"
            v-for="(item, index) in navlist"
            @click="changetab(item.dictValue, item.remark)"
            :key="index"
            >{{ item.dictName }}</a
          >
        </div>
      </div>
    </div> -->
      <div class="nav">
        <div class="title">公告公示</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue, item.remark)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div>
      <div class="content">
        <!-- 循环navlist 对应显示内容 -->
        <div class="tabdiv">
          <ul>
            <li class="on">{{ navlist[this.tid].dictName }}</li>
          </ul>
          <div class="tablist">
            <ul>
              <li
                @click="toinfo(item.id)"
                v-for="(item, index) in datalist"
                :key="index"
              >
                <p>
                  {{ item.title }}
                </p>
                <span>{{
                  item.createDate ? item.createDate.split(" ")[0] : ""
                }}</span>
              </li>
            </ul>
          </div>
          <!-- <div class="tablist" v-if="tabid == 1">
          <ul>
            <li @click="toinfo(1)">
              <p>
                212323华能新能源辽宁分公司下属风电场升压站电气类消防改造工程招标公告
              </p>
              <span>2020-09-16</span>
            </li>
          </ul>
        </div> -->
          <div class="search">
            <el-input
              placeholder="请输入关键字"
              clearable
              v-model="keyword"
              size="small"
              class="input-with-select"
            >
              <el-button
                slot="append"
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="getinfo"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="pageno">
          <el-pagination
            background
            :current-page="pageno"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      tid: "",
      pageno: 1,
      navlist: [],
      total: 0,
      datalist: []
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.pageno = this.$route.query.pageno - 0;
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));
        var navlist = nav.filter(item => {
          return item.parent.code === "wesiteNotice";
        })[0].child;
        this.navlist = navlist;
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    getinfo() {
      this.$get(
        "/website/fbggPage?menuCode=wesiteNotice&titleType=" +
          this.tid +
          "&limit=10&page=" +
          this.pageno +
          "&title=" +
          this.keyword
      ).then(res => {
        this.datalist = res.data.list;
        this.total = res.data.total;
      });
    },
    toinfo(id) {
      this.$router.push({
        path: "/notice/noticeinfo",
        query: { tid: this.tid, id: id }
      });
    },
    handleCurrentChange(val) {
      // window.scrollTo(0, 0);
      this.$router.push({
        path: "/notice/notice",
        query: { tid: this.tid, pageno: val }
      });
    },
    changetab(index, remark) {
      this.keyword = "";
      if (index === "999") {
        window.open(remark);
      } else {
        this.$router.push({
          path: "/notice/notice",
          query: { tid: index, pageno: 1 }
        });
      }
    }
    // changetabdiv(index) {
    //   this.$router.push({
    //     path: "/notice/notice",
    //     query: { tid: this.tid, tabid: index, pageno: 1 }
    //   });
    // }
  }
};
</script>
<style scoped>
.pageno {
  padding-top: 20px;
  text-align: right;
}
.tablist {
  width: 100%;
}
.tablist ul {
  width: 100%;
}
.tablist ul li {
  width: 100%;
  height: 60px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
}
.tablist li p {
  font-size: 15px;
  flex: 1;
  line-height: 20px;
}
.tablist li span {
  color: #666;
  width: 120px;
  text-align: right;
  font-size: 16px;
}
.tablist li:hover p,
.tablist li:hover span {
  color: #168eca;
}
.search {
  width: 300px;
  position: absolute;
  right: 0;
  top: 0;
}
.tabdiv {
  position: relative;
}
.tabdiv > ul {
  border-bottom: 1px solid rgb(104, 144, 206);
}
.tabdiv > ul li {
  padding: 0px 25px;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 16px;
}
.tabdiv > ul li.on,
.tabdiv > ul li:hover {
  border: 1px solid rgb(108, 105, 165);
  background: rgb(108, 105, 165);
  cursor: pointer;
  color: #fff;
}
/* .content {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
} */
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
